import { Link } from "react-router-dom";
import useSeo from "../lib/useSeo";
import PromoBanner from "../components/PromoBanner";

const SITE_URL =
  process.env.REACT_APP_SITE_URL || "https://evonpolishing.com";
const ASSET_URL = process.env.PUBLIC_URL || "";

export default function Home() {
  useSeo({
    title: "Evon Polishing | Liturgical Metalware Restoration",
    description:
      "Expert restoration of chalices, ciboria, monstrances, and sacred Catholic metalware through careful polishing and precious-metal plating.",
    canonical: `${SITE_URL}/`,
    ogImage: `${SITE_URL}${ASSET_URL}/images/hero-split.jpg`,
  });

  return (
    <>
      {/* ================= HERO (Split Before / After) ================= */}
      <section className="hero hero-split">
        <div className="hero-media">
          <img
            src={`${ASSET_URL}/images/hero.png`}
            alt="Before and after chalice restoration"
          />
        </div>

        <div className="hero-overlay-content">
          <h1>Restoring Sacred Metalware with Care and Reverence</h1>
          <p className="hero-sub">
            Expert restoration of chalices, monstrances, ciboria, and other
            liturgical treasures.
          </p>

          <Link to="/contact" className="btn primary">
            Request a Restoration Evaluation
          </Link>
        </div>
      </section>

      <PromoBanner/>

      {/* ================= SERVICE CATEGORIES ================= */}
      <section className="section paper">
        <div className="container">
          <div className="grid three service-tiles">
            <Link to="/services" className="service-tile">
              <img
                src={`${ASSET_URL}/images/tile1.png`}
                alt="Chalices and ciboria"
              />
              <div className="service-tile-label">
                <h3>Chalices &amp; Ciboria</h3>
                <p>Reviving sacred vessels.</p>
              </div>
            </Link>

            <Link to="/services" className="service-tile">
              <img
                src={`${ASSET_URL}/images/tile2.png`}
                alt="Monstrance restoration"
              />
              <div className="service-tile-label">
                <h3>Monstrances</h3>
                <p>Restoring radiant beauty.</p>
              </div>
            </Link>

            <Link to="/services" className="service-tile">
              <img
                src={`${ASSET_URL}/images/tile3.png`}
                alt="Thuribles and other metalware"
              />
              <div className="service-tile-label">
                <h3>Thuribles &amp; More</h3>
                <p>Expert metalwork restoration.</p>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* ================= PROCESS ================= */}
      <section className="section stone">
        <div className="container">
          <header className="section-head center">
            <h2>Our Restoration Process</h2>
          </header>

          <div className="grid four process-icons">
            <div className="process-step">
              <img
                src={`${ASSET_URL}/icons/icon1.png`}
                alt="Thuribles and other metalware"
                width="60"
                height="60"
              />
              <h4>Assessment &amp; Quote</h4>
            </div>

            <div className="process-step">
              <img
                src={`${ASSET_URL}/icons/icon2.png`}
                alt="Thuribles and other metalware"
                width="60"
                height="60"
              />
              <h4>Careful Restoration</h4>
            </div>

            <div className="process-step">
              <img
                src={`${ASSET_URL}/icons/icon3.png`}
                alt="Thuribles and other metalware"
                width="60"
                height="60"
              />
              <h4>Final Inspection</h4>
            </div>

            <div className="process-step">
              <img
                src={`${ASSET_URL}/icons/icon4.png`}
                alt="Thuribles and other metalware"
                width="60"
                height="60"
              />
              <h4>Secure Return</h4>
            </div>
          </div>
        </div>
      </section>

      {/* ================= BEFORE & AFTER ================= */}
      <section className="section paper">
        <div className="container">
          <header className="section-head center">
            <h2>Before &amp; After</h2>
          </header>

          <div className="grid two ba-showcase">
            <figure className="ba-frame">
              <img
                src={`${ASSET_URL}/images/before.png`}
                alt="Before restoration"
              />
              <figcaption>Before</figcaption>
            </figure>

            <figure className="ba-frame">
              <img
                src={`${ASSET_URL}/images/after.png`}
                alt="After restoration"
              />
              <figcaption>After</figcaption>
            </figure>
          </div>
        </div>
      </section>

      {/* ================= ABOUT / CTA ================= */}
      <section className="section stone">
        <div className="container narrow center">
          <h2>About Evon Polishing</h2>
          <p className="muted">
            Dedicated to preserving the beauty, dignity, and sanctity of
            liturgical artifacts through skilled restoration and reverent care.
          </p>

          <Link to="/contact" className="btn primary">
            Request Evaluation
          </Link>
        </div>
      </section>
    </>
  );
}
